import { defineStore } from "pinia";
import axios from "axios";
import { userManager } from "@/auth/oidc";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    user: null,
  }),
  getters: {
    isAuthenticated: (s) => !!s.user && !s.user.expired,
  },
  actions: {
    async init() {
      const user = await userManager.getUser();
      if (user && !user.expired) {
        this.user = user;
        axios.defaults.headers.common.Authorization = `Bearer ${user.access_token}`;
      } else {
        this.user = null;
        delete axios.defaults.headers.common.Authorization;
      }
    },
    login(returnPath = "/") {
      return userManager.signinRedirect({ state: returnPath });
    },
    async completeLogin() {
      const user = await userManager.signinRedirectCallback();
      this.user = user;
      axios.defaults.headers.common.Authorization = `Bearer ${user.access_token}`;
      return user.state || "/";
    },
    logout() {
      return userManager.signoutRedirect();
    },
    async completeLogout() {
      await userManager.signoutRedirectCallback();
      this.user = null;
      delete axios.defaults.headers.common.Authorization;
    },
  },
});
